import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track5GRed = ({ state, workState, onLabelClick }) => (
	<g id="Track5GRed" transform="translate(1461.000000, 561.000000)" className="track">
		<path
			d="M210,4.54747351e-13 L31.0268447,51.1351872 C13.5999581,56.1142977 3.06830127,73.8073557 7,91.5 L7,91.5 L7,91.5"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			strokeWidth={tracksWidth} strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track5GRed')}
			coords="87.000000, 13.278622"
			text="5G"
			textCoordsX="9.88330078"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track5GRed.propTypes = trackPropTypes;

export default Track5GRed;
